import Helper from '@ember/component/helper';
import _pluralize from 'cio/utils/pluralize';

export function pluralize([count, word]) {
  return _pluralize(parseFloat(count), word);
}

export default Helper.helper(pluralize);
